import APICRUD from './apiCrud'
import URL from './urls'

export class AgentsEvents extends APICRUD {
  save(data) {
    return this.http().post(URL.EVENTS_URL, data)
  }
  index(options) {
    return this.http().get(`${URL.EVENTS_URL}/${options.start}/${options.end} `)
  }
  getAvailableTime(options) {
    return this.http().get(
      `${URL.AVAILABLE_TIME_URL}/${options.start}/${options.end} `
    )
  }

  update(data) {
    return this.http().put(URL.AGENT_EVENTS_UPDATE_URL, data)
  }

  delete(event, removeCopies = false) {
    const { comment, user_id } = event

    return this.http().delete(`${URL.EVENTS_URL}/${event.id} `, {
      data: {
        event,
        comment,
        user_id,
        removeCopies
      }
    })
  }
}

export default new AgentsEvents()
